import {Component, computed, input} from '@angular/core';
import {MediaModule} from '@spartacus/storefront';
import {DcpResourceData} from '@app/model/dcp-resource-data';
import {ProductTypeDisplayComponent} from '../product-type-display/product-type-display.component';

@Component({
    selector: 'dcp-product-tile-content',
    templateUrl: './product-tile-content.component.html',
    styleUrls: ['./product-tile-content.component.scss'],
    standalone: true,
    imports: [MediaModule, ProductTypeDisplayComponent],
})
export class ProductTileContentComponent {
  imageTop = input<boolean>(true);
  resource = input.required<DcpResourceData>();

  hasImage = computed(() => !!this.resource()?.source);
  hasLabel = computed(() => !!this.resource()?.label);
  hasDescription = computed(() => !!this.resource()?.description);
  headlineSize = computed(() => this.hasImage() && this.hasDescription() ? 'xs' : 's');
}
